import { z } from 'zod';

export const linkQuery = (key: string = 'link') => /* graphql */ `
  ${key} {
    url
    title
    target
  }
`;

export const linkSchema = z.object({
  url: z.string(),
  title: z.string(),
  target: z.string(),
});

export type LinkSchema = z.infer<typeof linkSchema>;
